export const LOCAL_STORAGE_INSTANCE_ID_KEY = 'opal:instanceId';
export const INSTANCE_ID_QUERY_PARAM_KEY = 'instanceId';
export const OPAL_ANALYTICS_STORAGE_KEY = 'ai-chat:ANALYTICS_STORAGE_KEY';
export const OPAL_APP_BASE_URL_STORAGE_KEY = 'ai-chat:OPAL_APP_BASE_URL';
export const AGENT_TEST_RUN_INSTANCE_OVERRIDE_KEY = 'opal:agentTestRunInstanceOverride';
